// eslint-disable-next-line import/no-cycle
import api from '../axios';
/* eslint-disable */
export const apiGetUserInfo = params => api.post('/user/home/get', params);
// 获取游客临时im的token
export const apiGetIMUserInfo = params => api.post('/im/getVisitorImUserToken', params);
// 获取登录用户im的token
export const apiGetIMLoginUserInfo = params => api.post('/im/getImUserToken', params);
// 图片上传
export const apiUploadFile = params =>
  api.post('/file/pic/upload', params, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
// 分享接口
export const apiShareVideoInfo = params => api.post('/video/shareVideoInfo', params);
// 直播观看上报
export const apiLiveReport = params => api.post('/user/view/report/h5Report', params);
// 获取登录用户信息
export const apiGetSelf = params => api.post('/user/self/get', params);
// 微医短视频界面用户信息
export const apiGetAppUserinfo = params => api.post('/user/vod/userinfo/get', params);